import { formatDateWithLocalTZ } from "@ticomix/common";
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import { ITwoFactorResponse } from "./i-itwo-factor-response";
import { throwException, blobToText } from "./api-utilities";

export class TwoFactorResponse implements ITwoFactorResponse {
  SharedKey!: string;
  RecoveryCodes?: string[] | null;
  RecoveryCodesLeft!: number;
  IsTwoFactorEnabled!: boolean;
  IsMachineRemembered!: boolean;

  constructor(data?: ITwoFactorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.SharedKey = "";
      this.RecoveryCodesLeft = 0;
      this.IsTwoFactorEnabled = false;
      this.IsMachineRemembered = false;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.SharedKey =
        _data["SharedKey"] !== undefined ? _data["SharedKey"] : "";
      if (Array.isArray(_data["RecoveryCodes"])) {
        this.RecoveryCodes = [] as any;
        for (let item of _data["RecoveryCodes"]) this.RecoveryCodes!.push(item);
      } else {
        this.RecoveryCodes = <any>null;
      }
      this.RecoveryCodesLeft =
        _data["RecoveryCodesLeft"] !== undefined
          ? _data["RecoveryCodesLeft"]
          : 0;
      this.IsTwoFactorEnabled =
        _data["IsTwoFactorEnabled"] !== undefined
          ? _data["IsTwoFactorEnabled"]
          : false;
      this.IsMachineRemembered =
        _data["IsMachineRemembered"] !== undefined
          ? _data["IsMachineRemembered"]
          : false;
    }
  }

  static fromJS(data: any): TwoFactorResponse {
    data = typeof data === "object" ? data : {};
    let result = new TwoFactorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["SharedKey"] =
      this.SharedKey !== undefined ? this.SharedKey : <any>null;
    if (Array.isArray(this.RecoveryCodes)) {
      data["RecoveryCodes"] = [];
      for (let item of this.RecoveryCodes) data["RecoveryCodes"].push(item);
    }
    data["RecoveryCodesLeft"] =
      this.RecoveryCodesLeft !== undefined ? this.RecoveryCodesLeft : <any>null;
    data["IsTwoFactorEnabled"] =
      this.IsTwoFactorEnabled !== undefined
        ? this.IsTwoFactorEnabled
        : <any>null;
    data["IsMachineRemembered"] =
      this.IsMachineRemembered !== undefined
        ? this.IsMachineRemembered
        : <any>null;
    return data;
  }
}
